import { Component, Vue } from 'vue-property-decorator';
import WorldMap from '@/components/WorldMap/WorldMap'
import LogoBar from '@/components/LogoBar/LogoBar'

@Component<LandingsPage>({
  components: {
    WorldMap,
    LogoBar,
  },
})
export default class LandingsPage extends Vue {
  protected isScrolled: boolean = false;

  public mounted() {
    //
  }

  public created() {
    window.addEventListener('scroll', this.checkScroll);
  }

  public destroyed() {
    window.removeEventListener('scroll', this.checkScroll);
  }

  protected checkScroll() {
    const scrollObject = {
      y: window.pageYOffset
    }
    
    if (scrollObject.y > 30) this.isScrolled = true;
    if (scrollObject.y < 30) this.isScrolled = false;
  }

}
